import { render, staticRenderFns } from "./MenuSelectPopup.vue?vue&type=template&id=3c70da34&scoped=true&"
import script from "./MenuSelectPopup.vue?vue&type=script&lang=js&"
export * from "./MenuSelectPopup.vue?vue&type=script&lang=js&"
import style0 from "./MenuSelectPopup.vue?vue&type=style&index=0&id=3c70da34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c70da34",
  null
  
)

export default component.exports